import React from 'react';
import PropTypes from 'prop-types';

import { short } from '../common/formatting/date';
import { Button } from '../../../components';

const RPMPanel = ({ rpmData = {}, onViewData }) => {
	const handleViewData = () => {
		onViewData(rpmData);
	};

	return (
		<div className="panel panel-default">
			<div className="panel-body">
				<h1>{rpmData.name_first} {rpmData.name_last}</h1>
				<h4>{rpmData.vital_name} {short(rpmData.vital_date)}</h4>
			</div>
			<div className="panel-footer text-right">
				<Button
					primary
					onClick={handleViewData}
					title="View Data"
				/>
			</div>
		</div>
	);
};

RPMPanel.propTypes = {
	rpmData: PropTypes.object,
	onViewData: PropTypes.func.isRequired,
};

export default RPMPanel;
